 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"VATDeclaration-vue~admin-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vu~6ec9cd7f":"VATDeclaration-vue~admin-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vu~6ec9cd7f","VATDeclaration-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParse~6751ed14":"VATDeclaration-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParse~6751ed14","VATDeclaration-vue":"VATDeclaration-vue","camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParser-vue~dashboard-vue~fab40d5a":"camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParser-vue~dashboard-vue~fab40d5a","camt053Parser-vue":"camt053Parser-vue","clients-vue~cratesBalance-vue~dashboard-vue~invoices-vue~items-vue~itemsRevenue-vue~itemsRevenueByCl~472c00d4":"clients-vue~cratesBalance-vue~dashboard-vue~invoices-vue~items-vue~itemsRevenue-vue~itemsRevenueByCl~472c00d4","clients-vue":"clients-vue","cratesBalance-vue":"cratesBalance-vue","dashboard-vue":"dashboard-vue","invoices-vue":"invoices-vue","items-vue":"items-vue","itemsRevenue-vue":"itemsRevenue-vue","itemsRevenueByClient-vue":"itemsRevenueByClient-vue","itemsSalesHistory-vue":"itemsSalesHistory-vue","newOrder-vue":"newOrder-vue","newPurchaseOrder-vue":"newPurchaseOrder-vue","orders-vue":"orders-vue","purchaseItems-vue":"purchaseItems-vue","quotes-vue":"quotes-vue","sortItems-vue":"sortItems-vue","timesheets-vue":"timesheets-vue","clientsCratesBalance-vue":"clientsCratesBalance-vue","createPayment2-vue~settings-vue~suppliers-vue~traceability-vue":"createPayment2-vue~settings-vue~suppliers-vue~traceability-vue","suppliers-vue":"suppliers-vue","traceability-vue":"traceability-vue","csvParser-vue":"csvParser-vue","drivers-vue":"drivers-vue","employees-vue~settings-vue":"employees-vue~settings-vue","employees-vue":"employees-vue","lastOrderDate-vue":"lastOrderDate-vue","myDashboard-vue":"myDashboard-vue","myInvoices-vue":"myInvoices-vue","myOrders-vue":"myOrders-vue","priceAdjustments-vue":"priceAdjustments-vue","purchaseOrders-vue":"purchaseOrders-vue","traceabilityQR-vue":"traceabilityQR-vue","vehicles-vue":"vehicles-vue","viewQuote-vue":"viewQuote-vue","ledger-vue":"ledger-vue","myNewOrder-vue":"myNewOrder-vue","settings-vue":"settings-vue","icp-vue":"icp-vue","revenue-vue":"revenue-vue","revenue2-vue":"revenue2-vue","salesGB-vue":"salesGB-vue","salesOutsideEU-vue":"salesOutsideEU-vue","admin-vue":"admin-vue","login-vue":"login-vue","newAccount-vue":"newAccount-vue","outstandingDebtors-vue":"outstandingDebtors-vue","createPayment-vue":"createPayment-vue","createPayment2-vue":"createPayment2-vue","purchaseInvoices-vue":"purchaseInvoices-vue","redirect-vue":"redirect-vue","tables-vue":"tables-vue","tv-vue":"tv-vue"}[chunkId]||chunkId) + "." + {"VATDeclaration-vue~admin-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vu~6ec9cd7f":"77bc0be3","VATDeclaration-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParse~6751ed14":"b214b478","VATDeclaration-vue":"12b754b5","camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParser-vue~dashboard-vue~fab40d5a":"3c6260d0","camt053Parser-vue":"a8aaef4b","clients-vue~cratesBalance-vue~dashboard-vue~invoices-vue~items-vue~itemsRevenue-vue~itemsRevenueByCl~472c00d4":"3f1d1773","clients-vue":"007a49c4","cratesBalance-vue":"f17c4366","dashboard-vue":"adb82dd7","invoices-vue":"05f91fc5","items-vue":"0a4ddb8b","itemsRevenue-vue":"b61c7337","itemsRevenueByClient-vue":"91e81928","itemsSalesHistory-vue":"97701136","newOrder-vue":"81ef69ff","newPurchaseOrder-vue":"750744cb","orders-vue":"f081a476","purchaseItems-vue":"a506b3fb","quotes-vue":"3bfc7cb8","sortItems-vue":"5ace679e","timesheets-vue":"c2d8c721","clientsCratesBalance-vue":"5f3e48c7","createPayment2-vue~settings-vue~suppliers-vue~traceability-vue":"9bbfff9f","suppliers-vue":"248e6403","traceability-vue":"2425ad06","csvParser-vue":"94631ade","drivers-vue":"3012926d","employees-vue~settings-vue":"db3bfe08","employees-vue":"77916f67","lastOrderDate-vue":"fedaa569","myDashboard-vue":"23b9097c","myInvoices-vue":"b8489c1d","myOrders-vue":"9d0b8264","priceAdjustments-vue":"4922b6da","purchaseOrders-vue":"fb3a9b79","traceabilityQR-vue":"3433bdd3","vehicles-vue":"c11b3658","viewQuote-vue":"9cc270dc","ledger-vue":"cfb2827a","myNewOrder-vue":"44e546d7","settings-vue":"6e42a83b","icp-vue":"76a43756","revenue-vue":"d92fd643","revenue2-vue":"357bd887","salesGB-vue":"aec1fd83","salesOutsideEU-vue":"6b74c4de","admin-vue":"c4ea6c4d","login-vue":"c74039c3","newAccount-vue":"8354a290","outstandingDebtors-vue":"c60f9376","createPayment-vue":"a8379c30","createPayment2-vue":"e53a925b","purchaseInvoices-vue":"dc61c339","redirect-vue":"4e4e02a6","tables-vue":"dba5ef51","tv-vue":"d54c03d2","chunk-2d0ccba7":"a5cd6317","chunk-2d2254c5":"6662a59a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"VATDeclaration-vue~admin-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vu~6ec9cd7f":1,"VATDeclaration-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParse~6751ed14":1,"VATDeclaration-vue":1,"camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParser-vue~dashboard-vue~fab40d5a":1,"camt053Parser-vue":1,"clients-vue~cratesBalance-vue~dashboard-vue~invoices-vue~items-vue~itemsRevenue-vue~itemsRevenueByCl~472c00d4":1,"clients-vue":1,"cratesBalance-vue":1,"dashboard-vue":1,"invoices-vue":1,"items-vue":1,"itemsRevenue-vue":1,"itemsRevenueByClient-vue":1,"itemsSalesHistory-vue":1,"newOrder-vue":1,"newPurchaseOrder-vue":1,"orders-vue":1,"purchaseItems-vue":1,"quotes-vue":1,"sortItems-vue":1,"timesheets-vue":1,"clientsCratesBalance-vue":1,"suppliers-vue":1,"traceability-vue":1,"csvParser-vue":1,"drivers-vue":1,"employees-vue~settings-vue":1,"employees-vue":1,"lastOrderDate-vue":1,"myDashboard-vue":1,"myInvoices-vue":1,"myOrders-vue":1,"priceAdjustments-vue":1,"vehicles-vue":1,"viewQuote-vue":1,"ledger-vue":1,"myNewOrder-vue":1,"settings-vue":1,"icp-vue":1,"revenue-vue":1,"revenue2-vue":1,"salesGB-vue":1,"salesOutsideEU-vue":1,"admin-vue":1,"login-vue":1,"newAccount-vue":1,"outstandingDebtors-vue":1,"createPayment-vue":1,"redirect-vue":1,"tv-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"VATDeclaration-vue~admin-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vu~6ec9cd7f":"VATDeclaration-vue~admin-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vu~6ec9cd7f","VATDeclaration-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParse~6751ed14":"VATDeclaration-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParse~6751ed14","VATDeclaration-vue":"VATDeclaration-vue","camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParser-vue~dashboard-vue~fab40d5a":"camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParser-vue~dashboard-vue~fab40d5a","camt053Parser-vue":"camt053Parser-vue","clients-vue~cratesBalance-vue~dashboard-vue~invoices-vue~items-vue~itemsRevenue-vue~itemsRevenueByCl~472c00d4":"clients-vue~cratesBalance-vue~dashboard-vue~invoices-vue~items-vue~itemsRevenue-vue~itemsRevenueByCl~472c00d4","clients-vue":"clients-vue","cratesBalance-vue":"cratesBalance-vue","dashboard-vue":"dashboard-vue","invoices-vue":"invoices-vue","items-vue":"items-vue","itemsRevenue-vue":"itemsRevenue-vue","itemsRevenueByClient-vue":"itemsRevenueByClient-vue","itemsSalesHistory-vue":"itemsSalesHistory-vue","newOrder-vue":"newOrder-vue","newPurchaseOrder-vue":"newPurchaseOrder-vue","orders-vue":"orders-vue","purchaseItems-vue":"purchaseItems-vue","quotes-vue":"quotes-vue","sortItems-vue":"sortItems-vue","timesheets-vue":"timesheets-vue","clientsCratesBalance-vue":"clientsCratesBalance-vue","createPayment2-vue~settings-vue~suppliers-vue~traceability-vue":"createPayment2-vue~settings-vue~suppliers-vue~traceability-vue","suppliers-vue":"suppliers-vue","traceability-vue":"traceability-vue","csvParser-vue":"csvParser-vue","drivers-vue":"drivers-vue","employees-vue~settings-vue":"employees-vue~settings-vue","employees-vue":"employees-vue","lastOrderDate-vue":"lastOrderDate-vue","myDashboard-vue":"myDashboard-vue","myInvoices-vue":"myInvoices-vue","myOrders-vue":"myOrders-vue","priceAdjustments-vue":"priceAdjustments-vue","purchaseOrders-vue":"purchaseOrders-vue","traceabilityQR-vue":"traceabilityQR-vue","vehicles-vue":"vehicles-vue","viewQuote-vue":"viewQuote-vue","ledger-vue":"ledger-vue","myNewOrder-vue":"myNewOrder-vue","settings-vue":"settings-vue","icp-vue":"icp-vue","revenue-vue":"revenue-vue","revenue2-vue":"revenue2-vue","salesGB-vue":"salesGB-vue","salesOutsideEU-vue":"salesOutsideEU-vue","admin-vue":"admin-vue","login-vue":"login-vue","newAccount-vue":"newAccount-vue","outstandingDebtors-vue":"outstandingDebtors-vue","createPayment-vue":"createPayment-vue","createPayment2-vue":"createPayment2-vue","purchaseInvoices-vue":"purchaseInvoices-vue","redirect-vue":"redirect-vue","tables-vue":"tables-vue","tv-vue":"tv-vue"}[chunkId]||chunkId) + "." + {"VATDeclaration-vue~admin-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vu~6ec9cd7f":"11e0db0b","VATDeclaration-vue~camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParse~6751ed14":"aad8350b","VATDeclaration-vue":"f69fd4bf","camt053Parser-vue~clients-vue~clientsCratesBalance-vue~cratesBalance-vue~csvParser-vue~dashboard-vue~fab40d5a":"18bc4a4a","camt053Parser-vue":"5667ce14","clients-vue~cratesBalance-vue~dashboard-vue~invoices-vue~items-vue~itemsRevenue-vue~itemsRevenueByCl~472c00d4":"972131d9","clients-vue":"eaed7de4","cratesBalance-vue":"0b086002","dashboard-vue":"c0a2fccd","invoices-vue":"011cce16","items-vue":"0e9f0889","itemsRevenue-vue":"16d7dc7b","itemsRevenueByClient-vue":"678d8686","itemsSalesHistory-vue":"22c1a916","newOrder-vue":"4d8c0689","newPurchaseOrder-vue":"a02f8da8","orders-vue":"e4ddd677","purchaseItems-vue":"09b3538b","quotes-vue":"59ee17dc","sortItems-vue":"f90f72cf","timesheets-vue":"549b2212","clientsCratesBalance-vue":"3bf01d7c","createPayment2-vue~settings-vue~suppliers-vue~traceability-vue":"31d6cfe0","suppliers-vue":"3434d401","traceability-vue":"12c12e3e","csvParser-vue":"a047599e","drivers-vue":"060966bd","employees-vue~settings-vue":"ad727f56","employees-vue":"eaa6bfaf","lastOrderDate-vue":"dac32ffd","myDashboard-vue":"0e5cf4c7","myInvoices-vue":"12dfa6ed","myOrders-vue":"7e2edfc6","priceAdjustments-vue":"71a315dd","purchaseOrders-vue":"31d6cfe0","traceabilityQR-vue":"31d6cfe0","vehicles-vue":"060966bd","viewQuote-vue":"8c3b814e","ledger-vue":"d3f08814","myNewOrder-vue":"73e2fde0","settings-vue":"18694c96","icp-vue":"d2e83fdd","revenue-vue":"2625640b","revenue2-vue":"e1df1d8f","salesGB-vue":"98392c2b","salesOutsideEU-vue":"fea083cf","admin-vue":"eb235811","login-vue":"767843d0","newAccount-vue":"d14f5cc5","outstandingDebtors-vue":"dcafffb7","createPayment-vue":"d9becf01","createPayment2-vue":"31d6cfe0","purchaseInvoices-vue":"31d6cfe0","redirect-vue":"d9becf01","tables-vue":"31d6cfe0","tv-vue":"e8cbe139","chunk-2d0ccba7":"31d6cfe0","chunk-2d2254c5":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
